import * as api from '@/config/api'
import { logout } from '@/utils/auth'
import { getUserInfo } from '@/api/user/user'

const user = {
  state: {
    roles: [],
    info: {},
  },

  mutations: {
    SET_ROLES: (state, roles = []) => {
      // 至少有一个 default 页面
      state.roles = roles.concat(['default'])
    },

    SET_INFO: (state, info) => {
      state.info = info
    },
  },

  actions: {
    Login() {
      location.href = api.loginUrl
    },

    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            const data = res.data.data
            commit('SET_ROLES', data.permissions || [])
            commit('SET_INFO', data.info)
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    LogOut() {
      logout()
    },
  },
}

export default user
